const performanceDashboard = {
  supplierSelector: {
    label: 'Choose Fleet:',
  },
};

export default performanceDashboard;
